export default {
      id: "3-0-usage",
      viewBox: "0 0 88 88",
      url: "assets/" + "sprite.svg#3-0-usage",
      toString: function () {
        return this.url;
      }
    }